import { createReducer, on } from '@ngrx/store';
import { initialUIState } from './ui.state';
import { toggleSidebar, setSidebarItems } from './ui.actions';

export const uiFeatureKey = 'ui';

export const reducer = createReducer(
  initialUIState,
  on(toggleSidebar, (state) => ({ ...state, isSidebarOpen: !state.isSidebarOpen })),
  on(setSidebarItems, (state, { items }) => ({ ...state, sidebarItems: items, isLoading: false }))
);
